<template>
  <div class="container" style="padding-bottom: 20vh; padding-top: 100px;">
    <h1 ref="pageTitle">Organizations</h1>
    <!-- {{ users }} -->
    <hr>
    <div>
      <div class="row">
        <div class="col-lg-3 mt-2">
          <label class="filter-label">Organization Types</label>
          <!-- <select class="form-control" v-model="organizationTypeFilter">
            <option>All</option>
            <option v-for="(organizationType, index) in organizationTypes" :key="'organizationTypeFilter'+index">{{ organizationType }}</option>
          </select> -->
          <multiselect v-model="organizationTypeFilters" :options="organizationTypes" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Organization Types"></multiselect>
        </div>
        <div class="col-lg-3 mt-2">
          <label class="filter-label">Organization Sizes</label>
          <!-- <select class="form-control" v-model="sizeFilter">
            <option>All</option>
            <option v-for="(size, index) in sizes" :key="'sizeFilter'+index">{{ size }}</option>
          </select> -->
          <multiselect v-model="sizeFilters" :options="sizes" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Organization Sizes"></multiselect>
        </div>
        <div class="col-lg-3 mt-2">
          <label class="filter-label">Topic Areas</label>
          <!-- <select class="form-control" v-model="focusAreaFilter">
            <option>All</option>
            <option v-for="(focusArea, index) in focusAreas" :key="'focusAreaFilter'+index">{{ focusArea }}</option>
          </select> -->
          <multiselect v-model="focusAreaFilters" :options="focusAreas" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Focus Areas"></multiselect>
        </div>
        <div class="col-lg-3 mt-2">
          <label class="filter-label">Country</label>
          <!-- <select class="form-control" v-model="countryFilter">
            <option>All</option>
            <option v-for="(country, index) in countries" :key="'countryFilter'+index">{{ country }}</option>
          </select> -->
          <multiselect v-model="countryFilters" :options="countries" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Filter by Countries"></multiselect>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-lg-3 mt-3 ml-4">
          <input class="form-check-input" type="checkbox" v-model="alphabeticalOrder">
          <label class="form-check-label filter-label" style="margin-top: 0">Alphabetical Order</label>
        </div>
      </div> -->
    </div>


    <hr>
    <div>
      <div class="row" style="margin-left: auto; margin-right: auto; text-align: center; text-decoration: none;">
        <!-- <router-link :to="{ name: 'Employer Public Profile', params: { id: user.id } }" class="" target="_blank" style="text-decoration: none;"> -->
        <!-- <div v-for="user in filteredUsers" :key="user.id"> -->

        <!-- <div v-for="user in filteredUsers" :key="user.id" class="col-lg-3 mt-1 p-4" style="background-color: var(--bootstrapgrey); border-right: 4px solid white; border-left: 4px solid white;"> -->
        <div v-for="user in filteredUsers" :key="user.id" class="col-lg-3 mb-4" style="">
          <div class="p-4" style="border: solid 1px var(--thrivehiregrey); border-radius: 3px; height: 100%;">
            <router-link :to="{ name: 'Employer Public Profile', params: { id: user.id } }" class="" target="_blank" style="color: var(--coredarkcolor);">
              <div style="height: 150px;">
                <img :src="user.profile_pic" height="" alt="" style="max-height: 150px; max-width: 150px;">
              </div>
              <h5 style="font-weight: 700;" class="mt-4">{{ user.employer_name }}</h5>

              <p>{{ user.city }}<span v-if="user.city">, </span>{{ user.country }}</p>
              <p>{{ user.organization_type }}<span v-if="user.organization_type && user.size"> (</span>{{ user.size }}<span v-if="user.organization_type && user.size">)</span></p>
              <hr v-if="user.sectors[0]">
              <p v-for="(sector, index) in user.sectors" :key="'ShowSectors'+index">{{ sector }}</p>
            </router-link>
          </div>

        </div>

        <!-- </div> -->
        <!-- </router-link> -->
      </div>
    </div>

    <!-- {{ users }} -->
  </div>
</template>

<script>
  import axios from 'axios'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        users: [],

        organizationTypeFilter: 'All',
        organizationTypeFilters: [],
        organizationTypes: [],
        focusAreaFilter: 'All',
        focusAreaFilters: [],
        focusAreas: [],
        sizeFilter: 'All',
        sizeFilters: [],
        sizes: [],
        countryFilter: 'All',
        countryFilters: [],
        countries: [],

        alphabeticalOrder: true,

        fullpage: true, // this is used for the loading overlay
      }
    },
    created () {
      this.getUserData();

      this.sizes = this.$store.getters.organizationSizes
      this.organizationTypes = this.$store.getters.organizationTypes
      this.focusAreas = this.$store.getters.focusAreas
      this.countries = this.$store.getters.countries

      if (this.$route.params.type && (this.$route.params.type != 'All Organization Types')) {
        this.organizationTypeFilters.push(this.$route.params.type)
      }
      if (this.$route.params.country && (this.$route.params.country != 'All Countries')) {
        this.countryFilters.push(this.$route.params.country)
      }
      if (this.$route.params.topic && (this.$route.params.topic != 'All Topic Areas')) {
        this.focusAreaFilters.push(this.$route.params.topic)
      }
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    computed: {
      filteredUsers () {
        if (!this.users[0]) {
          return this.users
        }

        var sizeFilteredUsers = []
        // if (this.sizeFilter != 'All') {
        if (this.sizeFilters.length > 0) {
          for (var user in this.users) {
            // if (this.users[user].size == this.sizeFilter) {
            if (this.sizeFilters.includes(this.users[user].size)) {
              sizeFilteredUsers.push(this.users[user])
            }
          }
        }
        else {
          sizeFilteredUsers = this.users
        }

        var typeFilteredUsers = []
        // if (this.organizationTypeFilter != 'All') {
        //   for (var user in sizeFilteredUsers) {
        //     if (sizeFilteredUsers[user].organization_type == this.organizationTypeFilter) {
        //       typeFilteredUsers.push(sizeFilteredUsers[user])
        //     }
        //   }
        // }
        if (this.organizationTypeFilters.length > 0) {
          for (var user in sizeFilteredUsers) {
            if (this.organizationTypeFilters.includes(sizeFilteredUsers[user].organization_type)) {
              typeFilteredUsers.push(sizeFilteredUsers[user])
            }
          }
        }
        else {
          typeFilteredUsers = sizeFilteredUsers
        }

        var focusFilteredUsers = []
        // if (this.focusAreaFilter != 'All') {
        //   for (var user in typeFilteredUsers) {
        //     if (typeFilteredUsers[user].sectors.includes(this.focusAreaFilter)) {
        //       focusFilteredUsers.push(typeFilteredUsers[user])
        //     }
        //   }
        // }
        if (this.focusAreaFilters.length > 0) {
          for (var user in typeFilteredUsers) {
            for (var focusArea in this.focusAreaFilters) {
              if (typeFilteredUsers[user].sectors.includes(this.focusAreaFilters[focusArea])) {
                focusFilteredUsers.push(typeFilteredUsers[user])
                break
              }
            }
          }
        }
        else {
          focusFilteredUsers = typeFilteredUsers
        }

        var countryFilteredUsers = []
        // if (this.countryFilter != 'All') {
        if (this.countryFilters.length > 0) {
          for (var user in focusFilteredUsers) {
            // if (focusFilteredUsers[user].country == this.countryFilter) {
            if (this.countryFilters.includes(focusFilteredUsers[user].country)) {
              countryFilteredUsers.push(focusFilteredUsers[user])
            }
          }
        }
        else {
          countryFilteredUsers = focusFilteredUsers
        }

        if (this.alphabeticalOrder) {
          // https://flaviocopes.com/how-to-sort-array-of-objects-by-property-javascript/
          // https://stackoverflow.com/questions/2466356/javascript-object-list-sorting-by-object-property
          // https://stackoverflow.com/questions/6712034/sort-array-by-firstname-alphabetically-in-javascript
          countryFilteredUsers = countryFilteredUsers.sort((a, b) => ((a.employer_name.toUpperCase()) > (b.employer_name.toUpperCase())) ? 1 : -1)
          // https://www.w3schools.com/jsref/jsref_touppercase.asp - Upper and lower case letters were being ordered differently, need to convert first to keep consistency
        }

        return countryFilteredUsers
      },
    },
    methods: {
      getUserData() {

        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },3000)

        // axios.get('/api/people/?is_employer=true&agency=4')
        axios.get('/api/publicemployers/?status=Active&agency='+this.$store.getters.agencyID.toString())
          .then(res => {
            console.log('Getting employers')
            console.log(res.data)
            this.users = res.data
            // console.log(this.users[0])

            // this.users = this.users.sort((a, b) => (a.last_name[0] > b.last_name[0]) ? 1 : -1)
            // this.users = this.users.sort((a, b) => (a.last_updated_date > b.last_updated_date) ? 1 : -1)
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>

<style>
  .filter-label {
    /* margin-top: 5px; */
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/organizationBoard/OrganizationBoard.vue